import { __DEV__ } from "@/constants";
import { isNativeApp } from "@/models/platform";
import { version } from "../../package.json";
import { datadogLogs } from "@datadog/browser-logs";
import { useUISlice } from "@/models/useUISlice";
import { useAuth } from "@/models/useAuth";
import { getMobileOperatingSystem, getLocale } from "@/models/utils";

if (typeof window !== "undefined" && !__DEV__) {
  try {
    const env = "prod";
    const isNative = isNativeApp();

    datadogLogs.init({
      clientToken: import.meta.env.VITE_PUBLIC_DATADOG_CLIENT_TOKEN,
      site: "datadoghq.com",
      forwardErrorsToLogs: true,
      service: isNative ? "eznote-native" : "eznote-web",
      env,
      version,
      sessionSampleRate: 100,
    });

    if (useAuth.isAuthenticated()) {
      const user = useAuth.currentAuthUser();
      datadogLogs.setUser({ id: user?.userId, email: user?.email });
    }
  } catch (error) {
    console.error("Error initializing Datadog", error);
  }
}

export type FunnelEvent =
  | "[0] - page visited"
  | "[1] - user authenticated"
  | "[2] - upload started"
  | "[2.2] - upload completed"
  | "[3] - note created"
  | "[3.1] - note transcribed with speaker labels"
  | "[3.2] - note renamed"
  | "[3.3] - note deleted"
  | "[4] - transcript created"
  | "[4.1] - rename transcript speaker"
  | "[4.2] - edit transcript"
  | "[4.3] - transcript copied"
  | "[4.4] - transcript emailed"
  | "[4.5] - transcript downloaded"
  | "[5] - summary requested"
  | "[5.1] - summary created"
  | "[5.2] - summary edited"
  | "[5.3] - summary copied"
  | "[5.4] - summary emailed"
  | "[5.5] - summary downloaded"
  | "[5.6] - summary deleted"
  | "[6] - chat message sent"
  | "[6.1] - chat copied"
  | "[6.2] - chat cleared"
  | "[7] - folder created"
  | "[7.1] - folder renamed"
  | "[7.2] - folder deleted"
  | "[7.3] - add note to folder"
  | "[7.4] - remove note from folder"
  | "[7.5] - chat with folder"
  | "[7.6] - copy chat folder"
  | "[7.7] - clear chat folder"
  | "[8] - stripe checkout"
  | "[8.1] - stripe billing portal"
  | "[8.2] - stripe checkout success";

export const logFunnelEvent = (funnel: FunnelEvent) => {
  const user = useAuth.currentAuthUser();
  try {
    datadogLogs?.logger?.info(`[Funnel]${funnel}`, {
      funnelData: {
        platform: getMobileOperatingSystem(),
        isMobile: useUISlice?.getState()?.device?.isMobile,
        userId: user?.userId,
        email: user?.email,
        country: user?.country,
        ip: user?.ip,
        language: getLocale(),
        version,
      },
    });
  } catch (error) {}
};
